export const PrimaryColor = "#1E276D"
export const SecondaryColor = "#23d3d3"
